import Axios from "axios";

import Config from "../../Config";
import { getProducts, setCartItems } from "../../../store/Actions/cartActions";
import { reorderCart } from "../../../utils/pastOrders";

/*
 * Appels des commandes passées, mêmes routes que le mobile :
 *   GET  /customer/orders/:id/receipt → { url } (PDF signé)
 *   POST /customer/reviews            → { review }
 *   PUT  /customer/cart               (commander à nouveau)
 */

export const authHeaders = (authUser) => ({
  uid: authUser?.user_uid,
  client: authUser?.user_client,
  "access-token": authUser?.user_access_token,
});

export async function fetchReceiptUrl(orderId, authUser) {
  const response = await Axios({
    url: `${Config.apiURL}/customer/orders/${orderId}/receipt`,
    method: "GET",
    headers: authHeaders(authUser),
  });
  const url = response?.data?.url;
  if (!url) throw new Error("Receipt URL unavailable");
  return url;
}

/**
 * Ouvre le reçu dans un onglet. L'onglet est ouvert pendant le clic, avant
 * la requête, sinon le navigateur bloque la fenêtre ; il est refermé si le
 * reçu ne vient pas.
 */
export async function openReceipt(orderId, authUser) {
  const tab = window.open("", "_blank");
  try {
    const url = await fetchReceiptUrl(orderId, authUser);
    if (tab) {
      tab.opener = null;
      tab.location.href = url;
    } else {
      window.location.assign(url);
    }
  } catch (error) {
    if (tab) tab.close();
    throw error;
  }
}

export async function postReview({ stars, reviewContent, orderId }, authUser) {
  const response = await Axios({
    url: `${Config.apiURL}/customer/reviews`,
    method: "POST",
    headers: authHeaders(authUser),
    data: { stars, review_content: reviewContent, order_id: orderId },
  });
  return response?.data?.review;
}

/** Blanchisserie courante, écrite par getProducts ; parfois « undefined ». */
const storedLaundryId = () => {
  const n = Number(localStorage.getItem("laundry_id"));
  return Number.isFinite(n) && n > 0 ? n : null;
};

/**
 * Remplace le panier par les lignes de la commande (voir reorderCart). Le
 * panier et le catalogue sont lus dans le store au moment du clic ; le
 * catalogue est chargé s'il manque, car c'est lui qui dit quels produits
 * la blanchisserie propose encore.
 */
export const reorder = (order, authUser) => async (dispatch, getState) => {
  if (!getState()?.cart?.mockItems?.length) {
    await dispatch(getProducts());
  }
  const { cartItems, mockItems } = getState()?.cart || {};
  const available = new Set((mockItems || []).map((product) => product.id));
  const laundryId = storedLaundryId() ?? mockItems?.[0]?.laundry_id ?? null;
  const { attributes, added } = reorderCart(order, cartItems, laundryId, available);

  if (!added) {
    throw new Error("Nothing from this order is available any more");
  }

  const response = await Axios({
    url: `${Config.apiURL}/customer/cart`,
    method: "PUT",
    headers: authHeaders(authUser),
    data: { cart: { cart_products_attributes: attributes } },
  });
  dispatch(setCartItems(response?.data?.cart));
};
